import { Typography } from "@mui/material";
import React from "react";

const Component = (props) => {
  return (
    <Typography sx={{ m: 1, textAlign: "center" }}>
      Click here for{" "}
      <a
        href="https://www.travelmidweststats.com"
        target="_blank"
        rel="noopener noreferrer"
        className="hyper-links"
      >
        {" "}
        Travel Time Statistics{" "}
      </a>
    </Typography>
  );
};

const module = {
  routeProps: {
    path: "TravelTimeStatistics",
    component: Component,
  },
  name: "Travel Time Statistics",
  label: "Travel Time Statistics",
  title: "Travel Time Statistics",

  showOnMenu: true,
  hideFilter: true,
};

export default module;
